
export default function LaunchPlan() {
  const milestones = [
    {
      quarter: 'Q3 2026',
      title: 'Pilot Program Launch',
      description: 'Official pilot rollout with waitlist members in Bangsar, KLCC, and Mont\'Kiara areas',
      icon: 'ri-rocket-line',
      status: 'target',
    },
    {
      quarter: 'Q4 2026',
      title: 'Feature Expansion',
      description: 'Enhanced AI capabilities, corporate partnerships, and expanded coverage zones',
      icon: 'ri-add-circle-line',
      status: 'upcoming',
    },
    {
      quarter: 'Q1 2027',
      title: 'City-Wide Rollout',
      description: 'Full Kuala Lumpur coverage with optimised operations based on pilot feedback',
      icon: 'ri-global-line',
      status: 'upcoming',
    },
    {
      quarter: 'Q2 2027',
      title: 'Regional Expansion',
      description: 'Expansion to Selangor and other major Malaysian cities',
      icon: 'ri-map-2-line',
      status: 'upcoming',
    },
  ];

  return (
    <section id="launch-plan" className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-teal-100 rounded-full px-4 py-2 mb-4">
            <i className="ri-calendar-check-line text-teal-600 mr-2 w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-teal-700" style={{ fontFamily: "'Inter', sans-serif" }}>
              Pilot Program Q3 2026
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Roadmap to Launch
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
            A strategic phased rollout ensuring quality, reliability, and community-driven growth
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {milestones.map((milestone, index) => (
            <div
              key={index}
              className={`relative rounded-lg p-6 transition-all hover:-translate-y-1 ${
                milestone.status === 'target' 
                  ? 'bg-teal-600 text-white shadow-lg' 
                  : 'bg-white shadow-sm hover:shadow-md border border-gray-100'
              }`}
            >
              {milestone.status === 'target' && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-amber-400 text-amber-900 text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap" style={{ fontFamily: "'Inter', sans-serif" }}>
                  LAUNCH
                </div>
              )}
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${
                milestone.status === 'target' ? 'bg-white/20' : 'bg-teal-50'
              }`}>
                <i className={`${milestone.icon} text-2xl ${
                  milestone.status === 'target' ? 'text-white' : 'text-teal-600'
                } w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <span className={`text-sm font-bold mb-2 block ${
                milestone.status === 'target' ? 'text-teal-200' : 'text-teal-600'
              }`} style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {milestone.quarter}
              </span>
              <h3 className={`text-base font-bold mb-2 ${
                milestone.status === 'target' ? 'text-white' : 'text-gray-900'
              }`} style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {milestone.title}
              </h3>
              <p className={`text-sm leading-relaxed ${
                milestone.status === 'target' ? 'text-teal-100' : 'text-gray-600'
              }`} style={{ fontFamily: "'Inter', sans-serif" }}>
                {milestone.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
